import { Loading } from 'react-admin';
import Loadable from 'react-loadable';

const SessionsList = Loadable({ loader: () => import('./sessionsList'), loading: Loading });
const SessionsEdit = Loadable({ loader: () => import('./sessionsEdit'), loading: Loading });
const SessionsShow = Loadable({ loader: () => import('./sessionsShow'), loading: Loading });

export default { 
  list: SessionsList,
  edit: SessionsEdit,
  show: SessionsShow,
};